import { Box } from '@mui/material';
import AboutContent from '../components/AboutContent';

export default function About() {
  return (
    <Box sx={{ p: 2, maxWidth: 720, mx: 'auto' }}>
      <AboutContent />
    </Box>
  );
}
